<app-module-header [title]="organization.organizationName + ' - ' + 'Parkeringsöversikt'"
[icon]="'garage_home'"></app-module-header>

@if (isLoading) {
  <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
}

<mat-tab-group syncTabsWithUrl>
  <!-- Current Parking Tab -->
  <mat-tab label="Current Parking" urlKey="current">
    <div class="tab-content">
      <div class="parking-controls">
        <div class="parking-selector">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Parkering</mat-label>
            <mat-select [value]="parkingId" (selectionChange)="parkingChange($event)">
              @for (parking of organization.config.parkings; track parking) {
                <mat-option [value]="parking.parkingId">
                  {{ parking.parkingName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if (parkingSite) {
          <div class="parking-info">
            <div class="info-grid">
              <div class="info-item">
                <span class="label">Parkering</span>
                <span class="value">{{parkingSite.parkingSiteName}}</span>
              </div>
              <div class="info-item">
                <span class="label">Datum från</span>
                <span class="value">{{parkingSite.fromDate | date : 'yyyy-MM-dd'}}</span>
              </div>
              <div class="info-item">
                <span class="label">Datum till</span>
                <span class="value">{{parkingSite.toDate | date : 'yyyy-MM-dd'}}</span>
              </div>
              <div class="info-item">
                <span class="label">Lediga platser</span>
                <span class="value">{{parkingSite.availableParkingSpots}}</span>
              </div>
              <div class="info-item">
                <span class="label">Aktiva platser</span>
                <span class="value">{{parkingSite.activeParkingSpots}}</span>
              </div>
              <div class="info-item">
                <span class="label">Inaktiva platser</span>
                <span class="value">{{parkingSite.disabledParkingSpots}}</span>
              </div>
            </div>
            <div class="date-picker">
              <mat-form-field appearance="outline" class="w-100">
                <mat-date-range-input [formGroup]="dateSelectorGroup" [rangePicker]="picker">
                  <input matStartDate formControlName="dateFrom" placeholder="Startdatum">
                  <input matEndDate formControlName="dateTo" placeholder="Slutdatum"
                    (dateChange)="dateRangeChange($event)">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
            </div>
            <div class="checkboxes">
              <mat-checkbox [checked]="isParkingBookingMode" (change)="setParkingBookingMode($event.checked)">
                Bokningsläge
              </mat-checkbox>
              <mat-checkbox [checked]="isParkingCheckinMode" (change)="setParkingCheckinMode($event.checked)">
                Pågående parkeringar
              </mat-checkbox>
            </div>
          </div>
        }
      </div>

      <div class="scrolling-wrapper">

        @if (parkingSite) {
          <table class="table">
            @for (row of parkingSite.parkingSiteRows; track row) {
              <tr>
                <mat-card appearance="outlined" class="parking-site-card mat-elevation-z4 my-4">
                  <mat-card-header class="site-header">
                    <mat-card-title class="site-title">
                      <mat-icon class="header-icon">local_parking</mat-icon>
                      Rad {{ row.parkingSiteName }}
                    </mat-card-title>
                    <mat-card-subtitle class="site-subtitle">
                      <span class="status-badge clickable" [ngClass]="'status-' + $safeNavigationMigration(row.parkingSiteStatus?.toLowerCase())"
                        (click)="onRowStatusClick(row, $event)" [matMenuTriggerFor]="statusMenu">
                        {{ row.parkingSiteStatus }}
                        <mat-icon class="status-arrow">arrow_drop_down</mat-icon>
                      </span>
                      <span class="spot-count">
                        <mat-icon>local_parking</mat-icon> {{ row.parkingSiteSpots?.length }} platser
                        <span class="available-spots">
                          ({{ row.availableParkingSpots }} lediga)
                        </span>
                      </span>
                    </mat-card-subtitle>
                  </mat-card-header>
                  <!-- <mat-divider></mat-divider> -->
                  <mat-card-content class="spots-container">
                    @for (spot of row.parkingSiteSpots; track spot) {
                      <div [id]="'spot-' + spot.parkingSiteName"
                        class="spot-wrapper"
                        [ngClass]="spot.parkingSiteStatus === 'Disabled' ? 'spot-disabled' : 'spot-available'">
                        <div class="spot-header">
                          <h4 class="spot-title">{{ spot.parkingSiteName }}</h4>
                          <span class="spot-status clickable"
                            [ngClass]="'status-' + (spot.parkingSiteStatus?.toLowerCase() || '')"
                            (click)="onSpotStatusClick(spot, row, $event)" [matMenuTriggerFor]="statusMenu">
                            {{ spot.parkingSiteStatus }}
                            <mat-icon class="status-arrow">arrow_drop_down</mat-icon>
                          </span>
                        </div>
                        @for (booking of spot.parkingSiteSpotBookings; track booking) {
                          <div class="booking-card"
                            [ngClass]="{'checked-in': booking.status === 4, 'reserved': booking.status === 3}"
                            (click)="openOrder(booking, spot.parkingSiteName)">
                            @if (booking.overlapping) {
                              <div class="booking-header">
                                <mat-chip color="warn" class="overlap-chip" matTooltip="This booking has overlapping time slots">
                                  <mat-icon>warning</mat-icon>
                                  <span>Overlapping</span>
                                </mat-chip>
                              </div>
                            }
                            <div class="booking-details">
                              <div class="time-range">
                                <div class="time-block">
                                  <span class="time-label">Från</span>
                                  <span class="time-value">{{ booking.bookedFrom | date : 'yyyy-MM-dd' }}</span>
                                  <span class="time-value">{{ booking.bookedFrom | date : 'HH:mm' }}</span>
                                </div>
                                <mat-icon class="time-arrow">arrow_forward</mat-icon>
                                <div class="time-block">
                                  <span class="time-label">Till</span>
                                  <span class="time-value">{{ booking.bookedTo | date : 'yyyy-MM-dd' }}</span>
                                  <span class="time-value">{{ booking.bookedTo | date : 'HH:mm' }}</span>
                                </div>
                              </div>
                              <div class="vehicle-info">
                                <mat-icon>directions_car</mat-icon>
                                <span class="vehicle-plate">{{ booking.carId || 'Inget regnr' }}</span>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </mat-card-content>
                </mat-card>
              </tr>
            }
          </table>
        }
      </div>
    </div>
  </mat-tab>

  <!-- Parking Details Tab -->
  <mat-tab label="Parking Information" urlKey="details">
    <div class="tab-content">
      <app-org-parking-list (incrementRequests)="incrementRequests()" (decrementRequests)="decrementRequests()"
      [isLoading]="isLoading" [organization]="organization"></app-org-parking-list>
    </div>
  </mat-tab>

  <!-- Overlapping Parkings Tab -->
  <mat-tab label="Overlapping Parkings" urlKey="overlapping">
    <div class="tab-content">
      <div class="overlapping-header">
        <h3>Overlapping Parkings</h3>
        <button mat-mini-fab color="primary" (click)="loadOverlappingParkings()"
          matTooltip="Reload overlapping parkings">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>

      <!-- Search and Filter Section -->
      <div class="overlapping-filter-bar">
        <mat-form-field appearance="outline" class="filter-select">
          <mat-label>Search by</mat-label>
          <mat-select [(ngModel)]="overlappingSearchField" (selectionChange)="applyOverlappingFilters()">
            <mat-option value="parkingRowName">Row</mat-option>
            <mat-option value="parkingSpotName">Spot</mat-option>
            <mat-option value="carId">Car ID</mat-option>
            <mat-option value="parkingName">Parking Name</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-search">
          <mat-label>Search value</mat-label>
          <input matInput [(ngModel)]="overlappingSearchText" (ngModelChange)="applyOverlappingFilters()"
            placeholder="Type search text">
          <mat-icon matSuffix class="search-icon">search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-date-range">
          <mat-label>Parking From</mat-label>
          <mat-date-range-input [formGroup]="overlappingBookingFromRange" [rangePicker]="fromRangePicker">
            <input matStartDate formControlName="start" placeholder="From">
            <input matEndDate formControlName="end" placeholder="To">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="fromRangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #fromRangePicker></mat-date-range-picker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-date-range">
          <mat-label>Parking To</mat-label>
          <mat-date-range-input [formGroup]="overlappingBookingToRange" [rangePicker]="toRangePicker">
            <input matStartDate formControlName="start" placeholder="From">
            <input matEndDate formControlName="end" placeholder="To">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="toRangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #toRangePicker></mat-date-range-picker>
        </mat-form-field>

        <button mat-stroked-button (click)="clearOverlappingFilters()" class="clear-filters-btn">
          <mat-icon>clear</mat-icon>
          Clear Filters
        </button>
      </div>

      <div class="overlapping-table-container mat-elevation-z1">
        <table mat-table [dataSource]="overlappingParkings" class="w-100">

          <!-- Parking Name Column -->
          <ng-container matColumnDef="parkingName">
            <th mat-header-cell *matHeaderCellDef> Parking Name </th>
            <td mat-cell *matCellDef="let element"> {{element.parkingName}} </td>
          </ng-container>

          <!-- Row Name Column -->
          <ng-container matColumnDef="parkingRowName">
            <th mat-header-cell *matHeaderCellDef> Row </th>
            <td mat-cell *matCellDef="let element"> {{element.parkingRowName}} </td>
          </ng-container>

          <!-- Spot Name Column -->
          <ng-container matColumnDef="parkingSpotName">
            <th mat-header-cell *matHeaderCellDef> Spot </th>
            <td mat-cell *matCellDef="let element">
              <span class="spot-link"
                (click)="goToCurrentParking(element.parkingId, element.parkingSpotName); $event.stopPropagation()">
                {{element.parkingSpotName}}
              </span>
            </td>
          </ng-container>

          <!-- Car ID Column -->
          <ng-container matColumnDef="carId">
            <th mat-header-cell *matHeaderCellDef> Car ID </th>
            <td mat-cell *matCellDef="let element">
              <span class="car-badge">{{element.carId || 'None'}}</span>
            </td>
          </ng-container>

          <!-- Booked From Column -->
          <ng-container matColumnDef="bookedFrom">
            <th mat-header-cell *matHeaderCellDef> Parking From </th>
            <td mat-cell *matCellDef="let element"> {{element.bookedFrom | date: 'yyyy-MM-dd HH:mm'}} </td>
          </ng-container>

          <!-- Booked To Column -->
          <ng-container matColumnDef="bookedTo">
            <th mat-header-cell *matHeaderCellDef> Parking To </th>
            <td mat-cell *matCellDef="let element"> {{element.bookedTo | date: 'yyyy-MM-dd HH:mm'}} </td>
          </ng-container>

          <!-- Row definitions -->
          <tr mat-header-row *matHeaderRowDef="displayedColumnsOverlapping"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsOverlapping;" (click)="goToOrder(row.orderId)"
          class="clickable-row"></tr>
        </table>

        <!-- No Data State -->
        @if (overlappingParkings.length === 0) {
          <div class="no-data-msg">
            <mat-icon>info</mat-icon>
            <span>No overlapping parkings found.</span>
          </div>
        }
      </div>
    </div>
  </mat-tab>
</mat-tab-group>

<!-- Overlapping Parkings -->


<mat-menu #statusMenu="matMenu" class="p-0">
  <button mat-menu-item (click)="onStatusSelected('Active', statusContext)">
    <span class="status-badge status-active">Active</span>
  </button>
  <button mat-menu-item (click)="onStatusSelected('Disabled', statusContext)">
    <span class="status-badge status-disabled">Disabled</span>
  </button>
</mat-menu>